// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index';
// import * as socketApi from './common/js/socket'
// Vue.prototype.socketApi = socketApi;
window.Promise = Promise;
Vue.config.productionTip = false;
import iView from 'iview';
iView.Message.config({
    top: 300,
    duration: 5
});
import 'iview/dist/styles/iview.css';
import 'url-search-params-polyfill'
Vue.use(iView);

router.beforeEach((to, from, next) => {
    store.dispatch('setRouteName', {
        'routeName': to.name
    });
    next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store: store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js